<template>
    <main-layout>

        <app-header icon="tools">
        Operations offline
        </app-header>

        <action-bar :back="{name: 'home'}">
            <a class="btn add btn-full" id="main-action" href="javascript: void 0" @click="sync">
                <i class="icon-go"></i>
                <strong>Synchroniser</strong>
            </a>
        </action-bar>

        <div class="main-content list wrap" id="list-offline">

            <div v-for="action in actions" :key="action.id">
                <p>
                    <i :class="action.action === 'add' ? 'icon-add' : 'icon-edit'"></i>
                    {{ action.type }} <strong>{{ action.id }}</strong>
                </p>
            </div>

        </div>

    </main-layout>
</template>

<script>
import Offline from '../../js/models/Offline'
import Synchro from '../../js/core/Synchro'

export default {
    data(){
        return {
            actions: []
        }
    },
    methods: {
        async sync() {

            if(navigator.onLine){

                swal({
                    title: 'Lancement de la synchronisation',
                    type: 'warning',
                    showLoaderOnConfirm: true,
                    allowOutsideClick: false,
                }).then(() => {

                });

                await Synchro
                    .syncOfflineData()
                    .then(() => {

                        swal(
                            'Synchro effectuée',
                            'Vos données saisies sans connexion ont bien été synchronisées avec le serveur',
                            'success'
                        ).then(
                            () => {
                                this.$router.push({name: 'home'})
                            },
                            () => {
                                this.$router.push({name: 'home'})
                            },
                        )
                    })
                    .catch(() => {
                        swal(
                            'Problème de synchronisation',
                            "Un problème s'est produit lors de la synchro et une partie de vos données n'a pas été envoyée au serveur, veuillez réesayer plus tard",
                            'error'
                        ).then(
                            () => {
                                this.$router.push({name: 'home'})
                            },
                            () => {
                                this.$router.push({name: 'home'})
                            },
                        )

                    })

            } else {

                swal(
                    'Connexion nécessaire',
                    "Veuillez-vous connecter au réseau pour effectuer la synchronisation",
                    'error'
                )

            }

        },
        fetchActions(){
            Offline
                .getList()
                .then(data => this.actions = data)
                .catch()
        }
    },
    mounted(){
        this.fetchActions();
    }
}
</script>

<style>

#list-offline.list{
    padding-top: 20px;
}

#list-offline.list > div{
    height: 45px;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
}


</style>



// WEBPACK FOOTER //
// OfflineActions.vue?608e9cba